import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { Icon } from "ui/Icon"
import styles from "./ResourceConflictCard.module.css"

/**
 * A scheduling clash that is not a blackout — typically the same resource assigned to two
 * listings at once. Informational only: there is no action to take from here yet.
 */
const ResourceConflictCard = ({ conflict }) => (
  <article className={styles.card}>
    <Flex align="center" gap="var(--spacing-xs)">
      <Icon name="AlertTriangle" width={20} height={20} color="var(--color-warning)" />
      <span className={styles.title}>{conflict.label}</span>
    </Flex>
    {conflict.detail && <span className={styles.detail}>{conflict.detail}</span>}
  </article>
)

ResourceConflictCard.propTypes = {
  conflict: PropTypes.shape({
    type: PropTypes.string,
    label: PropTypes.string,
    detail: PropTypes.string
  }).isRequired
}

export default ResourceConflictCard
